import StudioAgentAPI from 'dashboard/api/studio/agent';
import { createStore } from '../captain/storeFactory';

export default createStore({
  name: 'StudioAgent',
  API: StudioAgentAPI,
});
